import { AdminPromo } from '../model/adminPromo';
import { AdminPromoList } from '../model/adminPromo-list';
export class PromoBuilder {
    static buildPromo(data) {
        const promo = new AdminPromo();
        promo.id = data.id;
        promo.code = data.code;
        promo.name = data.name;
        promo.begin_date = data.begin_date;
        promo.end_date = data.end_date;
        promo.dto = data.dto;
        promo.dto_euro = data.dto_euro;
        promo.lot_product = data.lot_product;
        promo.booking_begin_date = data.booking_begin_date;
        promo.booking_end_date = data.booking_end_date;
        promo.id_lot = data.id_lot;
        promo.id_product = data.id_product;
        promo.global_usage_limit = data.global_usage_limit;
        promo.per_client_usage_limit = data.per_client_usage_limit;
        return promo;
    }
    static buildPromoList(data) {
        const promos = new AdminPromoList();
        promos.page = data.page;
        promos.pagination = data.pagination;
        promos.total = data.total;
        promos.promotions = _.map(data.promotions, (promo) => {
            return PromoBuilder.buildPromo(promo);
        });
        return promos;
    }
}
//# sourceMappingURL=promo-builder.js.map